export default __webpack_public_path__ + "1d29490fd2a7838f990c90dc960f1b61.png";